export default "__VITE_ASSET__DSVCeerf__"